import { styled } from 'styled-components';

const StyledLogoContainer = styled.div`
	display: flex;
`;

const StyledLogo = styled.img`
	height: 40px;
`;

const StyledLabelContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: start;
	height: 40px;
	margin-left: 20px;
	font-family: 'GT Walsheim Pro';
	color: white;
`;

const StyledShopTitle = styled.div`
	font-size: 26px;
	font-weight: bold;
	text-transform: uppercase;
`;

const StyledShopName = styled.div`
	font-size: 12px;
	font-weight: 500;
	text-transform: uppercase;
	opacity: 0.5;
	margin-bottom: -1px;
`;

export {
	StyledLabelContainer,
	StyledLogo,
	StyledLogoContainer,
	StyledShopName,
	StyledShopTitle,
};
